export const PRODUCT = 'ATLAS VISUEL ECG PRO™'

export const PRODUCT_TAGLINE = 'INTERPRÉTATION ÉLECTROCARDIOGRAPHIQUE & RYTHMES CARDIAQUES'

/** Anchor id of the €27 purchase section */
export const OFFER_ANCHOR = '#offer'

export const CHECKOUT_URL = 'https://atlas-visuel-ecg.impultienda.ar/checkout'

const RES =
  'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/e63bb052-60a2-4bb3-822e-44b75f060cf4/'

/** Box-set mockup (hero, €27 offer and final CTA). */
export const MOCKUP_IMAGE = RES + '1793839632631_mockup-1080-7e2edeb6.png'

export const RESOURCES_BASE = RES

export const SUPPORT_EMAIL = 'kitonline27@gmail.com'

export const PRICE = '27 €'
export const COMPARE_PRICE = '97 €'

/** Meta Pixel ID — ATLAS VISUEL ECG PRO (France). */
export const PIXEL_ID = '1130064756384622'
